import { Link } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/v2/breadcrumb";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface UseBreadcrumbsOptions {
  items: BreadcrumbItem[];
}

/**
 * Hook to generate breadcrumb navigation consistently across the app
 * 
 * @example
 * const breadcrumbs = useBreadcrumbs({
 *   items: [
 *     { label: t("common.campaigns"), href: `/clients/${clientId}/campaigns` },
 *     { label: campaign?.name ?? t("common.campaign"), href: `/clients/${clientId}/campaigns/${campaignId}` },
 *     { label: t("common.edit") }
 *   ]
 * });
 */
export function useBreadcrumbs({ items }: UseBreadcrumbsOptions) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <div key={index} className="contents">
              <BreadcrumbItem>
                {isLast || !item.href ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={item.href}>{item.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </div>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
